import { Skeleton } from "antd";

import "./PlanSetsSkeleton.less";

interface IPlanSetsSkeletonProps {
    count?: number;
    "data-testid"?: string;
}

export function PlanSetsSkeleton({
    count = 3,
    "data-testid": dataTestId = "planSetsSkeleton",
}: Readonly<IPlanSetsSkeletonProps>) {
    return (
        <div className="PlanSetsSkeleton" data-testid={dataTestId} aria-busy="true">
            {Array.from({ length: count }).map((_, index) => (
                <div
                    key={index}
                    className="PlanSetsSkeletonItem"
                    data-testid={`planSetsSkeletonItem-${index}`}
                >
                    <Skeleton
                        active
                        paragraph={false}
                        title={{ width: "100%", style: { margin: 0, height: 21 } }}
                    />
                </div>
            ))}
        </div>
    );
}
